
/**
 * Fail with a nicely logged and formatted error.
 * @param args
 */
export function fail(...args: any) {
    console.error.apply(console, args)
    throw new Error(args.join(" "))
}
